import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const PrintLabel = () => {
  const { id, actionId, worker } = useParams();
  const [labelData, setLabelData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uziemienie, setUziemienie] = useState(false);
  const [podst, setPodst] = useState(false);
  const GetData = async () => {
    axios
      .get("http://83.144.125.123:5222/Document/GetLabelData", {
        params: {
          originId: actionId,
          worker: worker,
        },
      })
      .then(function (response) {
        // Handle the response
        setLabelData(response.data);
        setLoading(false);

        if (response.data.property3 == "1") {
          setPodst(true);
        } else if (response.data.property3 == "2") {
          setUziemienie(true);
        }

        setTimeout(() => {
          window.print();
        }, 1000);
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error?.response?.data);
        alert(
          "Wystapił nieoczekiwany błąd podczas wywołania funkcji /Document/GetLabelData. Skontaktuj się z administratorem systemu. Komuniakt zwrotny: " +
            error?.response?.data
        );
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    GetData();
  }, []);

  return (
    <div className="clearLayout">
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
      <div
        style={{
          lineHeight: "0.2",
          marginLeft: "5px",
        }}
      >
        <p style={{ fontSize: "20px" }}>
          ETYKIETA NIE ZOSTAŁA SKONFIGUROWANA. SKONTAKTUJ SIĘ Z COMPUTER CENTER.
        </p>
      </div>
    </div>
  );
};

export default PrintLabel;
